export default {
  "nav.home": "Strona główna",
  "nav.guide": "Pełny przewodnik",
  "nav.shopGuide": "Przewodnik zakupowy",
  "nav.categories": "Kategorie",
  "nav.faq": "FAQ",
  "nav.language": "Język",

  "announce": "Niezależne źródło informacji • Regularnie aktualizowane • Zawsze weryfikuj linki przed zamówieniem",

  "hero.badge": "Centrum zasobów USFans Spreadsheet",
  "hero.title": "USFans Spreadsheet — kompletny przewodnik po linkach, wysyłce i zakupach",
  "hero.subtitle": "Znajdź przydatne linki, szczere opinie, informacje o wysyłce, magazynie i kontroli jakości oraz wskazówki dotyczące kuponów i kodów rabatowych — wszystko w jednym przejrzystym miejscu.",
  "hero.cta1": "USFans Spreadsheet",
  "hero.cta2": "Kup teraz",
  "hero.trust": "Niezależne źródło • Świeżo aktualizowane • Bezpieczne korzystanie z linków",

  "dropdown.label": "Przeglądaj kategorie",
  "dropdown.placeholder": "Wybierz kategorię…",

  "categories.title": "Kupuj według kategorii",
  "categories.subtitle": "Przejdź bezpośrednio do produktów, których szukasz w USFans.",

  "about.title": "Czym jest USFans Spreadsheet?",
  "about.p1": "USFans Spreadsheet to uporządkowany zbiór linków do produktów i skrótów do kategorii, który pomaga szybciej znaleźć to, czego szukasz. Zamiast przeglądać niekończące się strony, arkusz grupuje produkty w znane kategorie — buty, bluzy, koszulki, kurtki i inne — dzięki czemu możesz od razu przejść do interesującego Cię działu.",
  "about.p2": "Nasz cel jest prosty: zebrać najważniejsze informacje i linki w przejrzystym, łatwym do przeglądania formacie. Opisujemy opinie, koszty wysyłki, zasady magazynu, kontrolę jakości, kupony i wskazówki bezpieczeństwa, abyś mógł podjąć pewniejszą decyzję przed złożeniem zamówienia.",

  "features.title": "Wszystko o USFans w jednym miejscu",
  "features.subtitle": "Sześć kluczowych tematów, które pomogą Ci zrozumieć usługę przed zakupem.",
  "feat.review.title": "Opinia o USFans",
  "feat.review.desc": "Poznaj najważniejsze informacje, zalety, wady i kwestie, które warto sprawdzić przed skorzystaniem z usługi.",
  "feat.shipping.title": "Koszt wysyłki USFans",
  "feat.shipping.desc": "Dowiedz się, jakie czynniki wpływają na cenę wysyłki i jak porównać dostępne opcje.",
  "feat.warehouse.title": "Magazyn USFans",
  "feat.warehouse.desc": "Poznaj podstawy przechowywania, obsługi i kontroli zamówień w magazynie.",
  "feat.legit.title": "Czy USFans jest wiarygodne",
  "feat.legit.desc": "Dowiedz się, jak samodzielnie ocenić wiarygodność strony, linków i sprzedawców.",
  "feat.coupon.title": "Kupon USFans",
  "feat.coupon.desc": "Odkryj, jak znaleźć promocje i sprawdzić, czy kod rabatowy jest nadal aktualny.",
  "feat.discount.title": "Kod rabatowy USFans",
  "feat.discount.desc": "Dowiedz się, jak sprawdzić ważność i warunki kodu przed jego użyciem przy kasie.",

  "why.title": "Dlaczego warto korzystać z naszego przewodnika?",
  "why.subtitle": "Przejrzysty, uporządkowany punkt startowy dla każdego, kto zaczyna przygodę z USFans.",
  "why.1": "Uporządkowane informacje",
  "why.2": "Praktyczne poradniki",
  "why.3": "Szczere porównania",
  "why.4": "Szczegóły kontroli jakości (QC)",
  "why.5": "Wyjaśnienia dotyczące wysyłki",
  "why.6": "Zalecenia bezpieczeństwa",
  "why.7": "Regularne aktualizacje",
  "why.8": "Łatwa nawigacja",

  "articleCta.title": "Nowy w USFans? Zacznij od naszego pełnego przewodnika",
  "articleCta.subtitle": "Instrukcja krok po kroku obejmująca kategorie, wysyłkę, QC, kupony i bezpieczeństwo — napisana z myślą o początkujących.",
  "articleCta.button": "Przeczytaj pełny przewodnik",

  "safety.title": "Bezpieczeństwo przede wszystkim",
  "safety.text": "Zawsze weryfikuj adres strony, linki, sprzedawcę, ceny, metody płatności i informacje o wysyłce przed podjęciem decyzji. Ta strona jest niezależnym źródłem informacji i nie gwarantuje dostępności, bezpieczeństwa ani aktualności usług stron trzecich.",
  "safety.cta": "Odwiedź Centrum Bezpieczeństwa",

  "faq.title": "Najczęściej zadawane pytania",
  "faq.1q": "Czym jest USFans Spreadsheet?",
  "faq.1a": "To uporządkowany zbiór linków do produktów USFans pogrupowanych w kategorie, takie jak buty, bluzy, koszulki, kurtki i akcesoria, który pomaga szybciej znaleźć produkty.",
  "faq.2q": "Czy USFans jest wiarygodne?",
  "faq.2a": "USFans to szeroko omawiana usługa, ale zawsze zalecamy samodzielną weryfikację linków, sprzedawców, cen i metod płatności przed zamówieniem. Żadnej usługi strony trzeciej nie można uznać za bezpieczną bez własnej kontroli.",
  "faq.3q": "Ile kosztuje wysyłka USFans?",
  "faq.3a": "Koszt wysyłki zależy od kilku czynników, m.in. kraju docelowego, wagi paczki, metody wysyłki i ewentualnych opłat magazynowych. Najlepiej porównać dostępne opcje przy kasie.",
  "faq.4q": "Gdzie znajdę kupony lub kody rabatowe USFans?",
  "faq.4a": "Promocje często się zmieniają. Zalecamy sprawdzać oficjalną stronę bezpośrednio i weryfikować datę ważności oraz warunki kodu przed jego użyciem.",
  "faq.5q": "Jak korzystać z USFans Spreadsheet?",
  "faq.5a": "Wystarczy wybrać kategorię z listy rozwijanej lub przycisków powyżej, a zostaniesz przeniesiony bezpośrednio do odpowiedniej strony USFans dla danego typu produktu.",

  "ctaBanner.title": "Gotowy, aby znaleźć to, czego szukasz w USFans?",
  "ctaBanner.subtitle": "Otwórz arkusz i przeglądaj przejrzysty zbiór linków, przewodników i porównań.",
  "ctaBanner.button": "Otwórz USFans Spreadsheet",

  "footer.tagline": "Niezależne źródło informacji o USFans Spreadsheet.",
  "footer.disclaimer": "Ta strona jest niezależnym źródłem informacji i nie jest powiązana ani sponsorowana przez USFans. Zawsze samodzielnie weryfikuj adresy URL, sprzedawców, ceny i usługi stron trzecich przed podjęciem działań.",
  "footer.nav": "Nawigacja",
  "footer.resources": "Zasoby",
  "footer.languages": "Języki",
  "footer.rights": "Wszelkie prawa zastrzeżone.",
  "footer.backHome": "Powrót do strony głównej",
};